import { isDefined } from '@freelancer/utils';
import type { ServiceOfferingAttachmentApi } from 'api-typings/service_offerings/service_offerings';
import type { ServiceOfferingAttachment } from './service-offering-attachments.model';

export function transformServiceOfferingAttachments(
  serviceOfferingAttachment: ServiceOfferingAttachmentApi,
): ServiceOfferingAttachment {
  return {
    id: serviceOfferingAttachment.id,
    serviceOfferingId: serviceOfferingAttachment.service_offering_id,
    attachmentUuid: serviceOfferingAttachment.attachment_uuid,
    createDate: serviceOfferingAttachment.create_date * 1000,
    deleteDate: serviceOfferingAttachment.delete_date
      ? serviceOfferingAttachment.delete_date * 1000
      : undefined,
    downloadableUrl: serviceOfferingAttachment.downloadable_url,
    position: isDefined(serviceOfferingAttachment.position)
      ? serviceOfferingAttachment.position
      : 99_999,
  };
}
